import React, { useMemo } from 'react';
import c from 'classnames';
import { useSelector } from 'react-redux';

import type { ImmutableRootState } from '@uncinc/react-drupal-core/types';

import { AccordionItem, WysiwygField } from '../../../../components';
import type { NodeFaqProps } from '..';

type NodeFaqInlineProps = Omit<NodeFaqProps, 'viewMode'>;

const NodeFaqInline: React.FC<NodeFaqInlineProps> = ({
  entity,
  className,
  showLabel = true,
}) => {
  const faq = entity.toJS();
  const uuid = faq.uuid[0].value;
  const title = faq.title[0].value;
  const theme = faq.field_themes[0]?.entity?.name[0].value;
  const body = faq.body[0]?.processed;

  const hash = useSelector<ImmutableRootState<string>, string>(
    (state) => state.getIn(['router', 'location', 'hash'], ''),
  );

  const initialCollapsed = useMemo(() => !(hash.slice(1) === uuid), [hash, uuid]);

  const classes = c('NodeFaqInline', 'NodeFaq', className);

  return (
    <AccordionItem
      id={uuid}
      className={classes}
      title={title}
      label={showLabel ? theme : undefined}
      initialCollapsed={initialCollapsed}
    >
      <WysiwygField html={body} />
    </AccordionItem>
  );
};

export default NodeFaqInline;
